<template>
  <div class="detail-info-container">
    <!-- 页面头部 -->
    <div class="detail-page-header">
      <div class="detail-back-box" @click="handleBack">
        <i class="el-icon-arrow-left"></i> 返回
      </div>
      <div class="detail-header-title">
        <i class="el-icon-share"></i>
        <span>{{ isEdit ? "编辑二维码" : "添加二维码" }}</span>
      </div>
      <div class="detail-header-badge">
        <el-tag :type="isEdit ? 'warning' : 'success'" size="small">
          {{ isEdit ? "编辑中" : "新增" }}
        </el-tag>
      </div>
    </div>

    <div class="content-box">
      <!-- 左侧：表单 -->
      <div class="detail-form-wrapper">
        <el-form
          ref="nodeForm"
          :model="formData"
          :rules="formRules"
          label-width="120px"
          size="small"
        >
          <!-- 基本信息 -->
          <div class="detail-info-section">
            <div class="detail-section-title">基本信息</div>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="二维码名称" prop="qrName">
                  <el-input
                    v-model="formData.qrName"
                    placeholder="请输入二维码名称"
                    autocomplete="off"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="推广类目" prop="bindCategoryId">
                  <el-radio-group
                    v-model="formData.bindCategoryId"
                    :disabled="isEdit"
                  >
                    <el-radio :label="0">全部服务</el-radio>
                    <el-radio :label="1">指定服务</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 指定服务配置（仅添加时显示） -->
          <div
            class="detail-info-section"
            v-if="!isEdit && formData.bindCategoryId == 1"
          >
            <div class="detail-section-title">服务选择</div>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="服务区域" prop="areaId">
                  <el-cascader
                    v-model="formData.areaId"
                    :options="areaList"
                    :props="{
                      value: 'areaId',
                      label: 'areaName',
                      children: 'childrenCity',
                    }"
                    placeholder="请选择服务区域"
                    style="width: 100%"
                    ref="areaCascader"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="服务技能" prop="categoryId">
                  <el-cascader
                    v-model="formData.categoryId"
                    :options="categoryList"
                    :props="{
                      value: 'categoryId',
                      label: 'categoryName',
                      children: 'childrenServiceItem',
                    }"
                    placeholder="请选择服务技能"
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="服务项目" prop="serviceId">
                  <el-select
                    v-model="formData.serviceId"
                    placeholder="请选择服务项目"
                    style="width: 100%"
                    @change="handleServiceChange"
                  >
                    <el-option
                      v-for="item in serviceList"
                      :key="item.serviceId"
                      :label="item.itemName"
                      :value="item.serviceId"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 推广Logo -->
          <div class="detail-info-section">
            <div class="detail-section-title">推广Logo</div>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="推广Logo" prop="logoUrl">
                  <Upload
                    v-if="!isEdit"
                    :imgUrl="formData.logoUrl || ''"
                    @backUrl="(data) => backUrl(data)"
                    @deleteImg="removeBusinessLicense()"
                  />
                  <div class="img-box" v-else>
                    <el-image
                      style="width: 100px; height: 100px"
                      :src="formData.qrCodeUrl"
                      :preview-src-list="[formData.qrCodeUrl]"
                    />
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 底部按钮 -->
          <div class="detail-form-footer">
            <el-button size="small" @click="handleBack">取消</el-button>
            <el-button
              type="primary"
              size="small"
              :loading="submitLoading"
              @click="submitForm"
            >
              确定
            </el-button>
          </div>
        </el-form>
      </div>

      <!-- ===== 右侧：完整服务项目预览 ===== -->
      <div class="preview-wrapper">
        <div class="phone-frame">
          <div class="phone-screen">
            <!-- 状态栏 -->
            <div class="status-bar">
              <span class="time">9:41</span>
              <div class="status-icons">
                <svg width="17" height="12" viewBox="0 0 17 12" fill="none">
                  <path
                    d="M1 4.5C1 3.67157 1.67157 3 2.5 3H3.5C4.32843 3 5 3.67157 5 4.5V10.5C5 11.3284 4.32843 12 3.5 12H2.5C1.67157 12 1 11.3284 1 10.5V4.5Z"
                    fill="white"
                  />
                  <path
                    d="M6 2.5C6 1.67157 6.67157 1 7.5 1H8.5C9.32843 1 10 1.67157 10 2.5V10.5C10 11.3284 9.32843 12 8.5 12H7.5C6.67157 12 6 11.3284 6 10.5V2.5Z"
                    fill="white"
                  />
                  <path
                    d="M11 0.5C11 0.223858 11.2239 0 11.5 0H12.5C12.7761 0 13 0.223858 13 0.5V10.5C13 10.7761 12.7761 11 12.5 11H11.5C11.2239 11 11 10.7761 11 10.5V0.5Z"
                    fill="white"
                  />
                  <rect
                    x="14"
                    y="2"
                    width="3"
                    height="8"
                    rx="0.5"
                    fill="white"
                    fill-opacity="0.3"
                  />
                </svg>
              </div>
            </div>

            <div class="top-title">商品详情</div>

            <div class="info-box">
              <!-- 空状态 -->
              <div v-if="!infoFrom.serviceId" class="preview-empty">
                <i class="el-icon-picture-outline"></i>
                <span>请选择服务项目</span>
              </div>

              <!-- 服务项目完整预览 -->
              <template v-else>
                <!-- 轮播图 -->
                <div class="banner-box">
                  <el-carousel height="200px">
                    <el-carousel-item
                      v-for="(item, index) in infoFrom.imageUrlList"
                      :key="index"
                    >
                      <img
                        :src="item"
                        style="width: 100%; height: 100%; object-fit: cover"
                      />
                    </el-carousel-item>
                  </el-carousel>
                </div>

                <!-- 商品内容 -->
                <div class="info-card">
                  <div class="price-sales">
                    <div class="flex-box" style="align-items: center">
                      <span class="price"
                        >¥{{
                          infoFrom.priceType == 1
                            ? infoFrom.basePrice
                            : currentPrice
                        }}</span
                      >
                      <span
                        class="original-price"
                        v-if="infoFrom.priceType == 3"
                        >¥{{ originalPrice || "价格" }}</span
                      >
                    </div>
                    <span class="sales">已售 10</span>
                  </div>
                  <div class="goods-name">
                    <span>{{ infoFrom.itemName || "服务名称" }}</span>
                    <span v-if="infoFrom.priceType != 3"
                      >【{{ infoFrom.basePrice || "单价" }}元{{
                        infoFrom.unit || "单位"
                      }}】</span
                    >
                    <span v-if="infoFrom.priceType == 3"
                      >【{{ specBasePrice }}元 {{ specName }}】</span
                    >
                  </div>
                  <div class="goods-brief">
                    {{ infoFrom.serviceContent || "暂无描述" }}
                  </div>
                </div>

                <!-- 规格选择 -->
                <div class="spec-card" v-if="infoFrom.priceType == 3">
                  <div class="spec-title">规格选择</div>
                  <div class="spec-list">
                    <div
                      v-for="(spec, idx) in infoFrom.serviceItemSpecList"
                      :key="idx"
                      class="spec-item"
                      :class="{ active: selectedSpecIndex === idx }"
                      @click="selectSpec(idx, spec.specName)"
                    >
                      {{ spec.specName }}
                    </div>
                  </div>
                </div>

                <!-- 数量选择 -->
                <div
                  class="quantity-card"
                  v-if="
                    infoFrom.priceType === 2 ||
                    (infoFrom.priceType === 3 && isShowOrderQuantity)
                  "
                >
                  <div>数量</div>
                  <el-input-number
                    v-model="previewQuantity"
                    :min="minOrderQuantity"
                    :max="maxOrderQuantity"
                    :step="1"
                    size="small"
                  ></el-input-number>
                </div>

                <!-- 服务须知、详情图文、注意事项 -->
                <div class="details-box">
                  <div class="details-box-serve">
                    <div class="details-box-serve-title">
                      {{ infoFrom.finallyTitle }}
                    </div>
                    <div class="details-box-serve-content">
                      <span
                        v-for="(item, index) in infoFrom.finallyContent"
                        :key="index"
                        >{{ item.contentMsg }}</span
                      >
                    </div>
                  </div>

                  <div class="details-box-info">
                    <div class="details-box-info-title">
                      <div class="details-box-info-li1"></div>
                      <div>详情图文</div>
                      <div class="details-box-info-li2"></div>
                    </div>
                    <img
                      :src="item"
                      alt=""
                      v-for="(item, index) in infoFrom.contentMsg"
                      :key="index"
                      class="details-box-info-img"
                    />
                  </div>

                  <div class="details-box-precautions">
                    <div class="details-box-precautions-title">
                      {{ infoFrom.firstTitle }}:
                    </div>
                    <div class="details-box-precautions-content">
                      <span
                        v-for="(item, index) in infoFrom.firstContent"
                        :key="index"
                        >{{ item.contentMsg }}</span
                      >
                    </div>
                  </div>
                </div>
              </template>
            </div>

            <!-- 底部操作栏 -->
            <div class="phone-footer">
              <div class="footer-btn-wrapper">
                <div class="footer-btn">
                  <i class="el-icon-share" style="font-size: 18px"></i>
                  <span>分享</span>
                </div>
                <div class="footer-btn">
                  <i class="el-icon-chat-dot-round" style="font-size: 18px"></i>
                  <span>客服</span>
                </div>
              </div>
              <div class="footer-btn buy-btn">立即购买</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  QueryAreaList,
  QrcodeGenerate,
  AddQrcode,
  ModifyChannelQr,
  GetServiceItemAllList,
  QueryServiceItemDetail,
} from "@/api/codeManage/index";
import Upload from "./Upload.vue";

export default {
  name: "AddQrCode",
  components: { Upload },
  props: {
    editRow: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      isEdit: false,
      submitLoading: false,
      serviceList: [],
      categoryList: [],
      areaList: [],
      infoFrom: {},
      formData: {
        qrName: null,
        bindCategoryId: 0,
        areaName: "",
        logoUrl: null,
        serviceId: null,
        areaId: [],
        categoryId: [],
        itemId: null, // 编辑时从 editRow 带入
      },
      formRules: {
        qrName: [
          { required: true, message: "请输入二维码名称", trigger: "blur" },
        ],
        bindCategoryId: [
          { required: true, message: "请选择推广类目", trigger: "change" },
        ],
      },
      // 预览相关
      quantity: 1,
      specName: "",
      selectedSpecIndex: 0,
      maxOrderQuantity: 100,
      previewQuantity: 1,
    };
  },
  computed: {
    currentPrice() {
      if (this.infoFrom.priceType == 1) return null;
      if (this.infoFrom.priceType == 2) {
        return this.infoFrom.basePrice * this.infoFrom.orderQuantity;
      }
      if (
        this.infoFrom.priceType == 3 &&
        this.infoFrom.serviceItemSpecList &&
        this.infoFrom.serviceItemSpecList.length > 0
      ) {
        const info =
          this.infoFrom.serviceItemSpecList[this.selectedSpecIndex || 0];
        return info.price * this.previewQuantity;
      }
    },
    originalPrice() {
      if (
        this.infoFrom.priceType == 3 &&
        this.infoFrom.serviceItemSpecList &&
        this.infoFrom.serviceItemSpecList.length > 0
      ) {
        const info =
          this.infoFrom.serviceItemSpecList[this.selectedSpecIndex || 0];
        return info.originalPrice * this.previewQuantity;
      }
    },
    specBasePrice() {
      if (this.infoFrom.priceType != 3) return null;
      if (
        !this.infoFrom.serviceItemSpecList ||
        this.infoFrom.serviceItemSpecList.length === 0
      )
        return null;
      const info =
        this.infoFrom.serviceItemSpecList[this.selectedSpecIndex || 0];
      return info.price;
    },
    minOrderQuantity() {
      if (this.infoFrom.priceType == 2) {
        this.previewQuantity = Number(this.infoFrom.orderQuantity);
        return Number(this.infoFrom.orderQuantity) || 1;
      }
      if (
        this.infoFrom.priceType == 3 &&
        this.infoFrom.serviceItemSpecList &&
        this.infoFrom.serviceItemSpecList.length > 0
      ) {
        const info =
          this.infoFrom.serviceItemSpecList[this.selectedSpecIndex || 0];
        this.previewQuantity = Number(info.orderQuantity);
        return Number(info.orderQuantity);
      }
    },
    isShowOrderQuantity() {
      if (
        this.infoFrom.priceType == 3 &&
        this.infoFrom.serviceItemSpecList &&
        this.infoFrom.serviceItemSpecList.length
      ) {
        this.quantity =
          this.infoFrom.serviceItemSpecList[
            this.selectedSpecIndex || 0
          ].orderQuantity;
        return this.infoFrom.serviceItemSpecList[this.selectedSpecIndex || 0]
          .isShowOrderQuantity;
      }
    },
  },
  watch: {
    // 服务区域变化时，清空服务项目选择（仅添加模式）
    "formData.areaId": {
      handler() {
        if (!this.isEdit) {
          this.resetServiceSelection();
          this.getServiceList();
        }
      },
      deep: true,
    },
    // 服务技能变化时，清空服务项目选择（仅添加模式）
    "formData.categoryId": {
      handler() {
        if (!this.isEdit) {
          this.resetServiceSelection();
          this.getServiceList();
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getCategoryList();
    this.getAreaList();
    if (this.editRow) {
      this.isEdit = true;
      this.formData = JSON.parse(JSON.stringify(this.editRow));
      // 编辑时直接根据 itemId 加载项目预览
      this.loadPreviewByItemId(this.formData.itemId);
    }
  },
  methods: {
    // ===== 清空服务项目选择 =====
    resetServiceSelection() {
      this.formData.serviceId = null;
      this.serviceList = [];
      this.infoFrom = {};
      this.selectedSpecIndex = 0;
      this.previewQuantity = 1;
      this.specName = "";
    },

    // ===== 获取下拉数据 =====
    getCategoryList() {
      QrcodeGenerate().then((res) => {
        if (res.data.isSuccess) {
          this.categoryList = res.data.data || [];
        }
      });
    },
    getAreaList() {
      QueryAreaList().then((res) => {
        if (res.data.isSuccess) {
          this.areaList = res.data.data || [];
        }
      });
    },

    // ===== 获取服务项目列表 =====
    getServiceList() {
      const categoryId = this.formData.categoryId.length
        ? this.formData.categoryId[this.formData.categoryId.length - 1]
        : null;
      const areaId = this.formData.areaId.length
        ? this.formData.areaId[this.formData.areaId.length - 1]
        : null;
      if (!categoryId || !areaId) {
        this.serviceList = [];
        return;
      }
      GetServiceItemAllList({
        categoryId,
        areaId,
        pageIndex: 1,
        pageSize: 100,
      }).then((res) => {
        if (res.data.isSuccess) {
          this.serviceList = res.data.data || [];
        }
      });
    },

    // ===== 添加模式：选择服务项目后查询详情并预览 =====
    handleServiceChange(serviceId) {
      if (!serviceId) {
        this.infoFrom = {};
        return;
      }
      const itemId = this.serviceList.find(
        (item) => item.serviceId === serviceId
      )?.itemId;
      this.loadPreviewByItemId(itemId);
    },

    // ===== 编辑模式：根据 itemId 直接加载预览 =====
    loadPreviewByItemId(itemId) {
      if (!itemId) return;
      QueryServiceItemDetail({ itemId }).then((res) => {
        if (res.data.isSuccess) {
          const form = res.data.data || {};

          // 处理图片列表
          if (form.imagesUrl && form.imagesUrl.length > 0) {
            const imageUrlList = [];
            form.imagesUrl.forEach((item) => {
              if (item.imageUrl) imageUrlList.push(item.imageUrl);
            });
            this.$set(form, "imageUrlList", imageUrlList);
          } else {
            this.$set(form, "imageUrlList", []);
          }

          // 解析 contentMsg 为数组
          form.contentMsg = form.contentMsg ? JSON.parse(form.contentMsg) : [];

          // 初始化预览状态
          this.selectedSpecIndex = 0;
          this.previewQuantity = 1;
          this.specName = "";
          if (form.serviceItemSpecList && form.serviceItemSpecList.length) {
            this.specName = form.serviceItemSpecList[0].specName;
          }

          this.infoFrom = form;
        }
      });
    },

    // ===== 规格切换 =====
    selectSpec(idx, specName) {
      this.selectedSpecIndex = idx;
      this.quantity = this.infoFrom.serviceItemSpecList[idx].orderQuantity;
      this.specName = specName;
    },

    // ===== 上传回调 =====
    backUrl(data) {
      this.$set(this.formData, "logoUrl", data);
    },
    removeBusinessLicense() {
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$set(this.formData, "logoUrl", "");
          this.$message.success("删除成功");
        })
        .catch(() => {});
    },

    // ===== 提交 =====
    submitForm() {
      this.$refs.nodeForm.validate((valid) => {
        if (!valid) return;
        this.submitLoading = true;

        if (this.isEdit) {
          ModifyChannelQr({
            qrId: this.formData.qrId,
            qrName: this.formData.qrName,
          })
            .then((res) => {
              if (res.data.isSuccess) {
                this.$message.success(res.data.message);
                this.$emit("success");
                this.handleBack();
              } else {
                this.$message.error(res.data.message);
              }
            })
            .finally(() => {
              this.submitLoading = false;
            });
        } else {
          if (this.formData.bindCategoryId == 1) {
            this.formData.areaName =
              this.$refs.areaCascader?.getCheckedNodes()[0]?.label || "";
          } else {
            this.formData.areaName = "";
          }
          AddQrcode(this.formData)
            .then((res) => {
              if (res.data.isSuccess) {
                this.$message.success(res.data.message);
                this.$emit("success");
                this.handleBack();
              } else {
                this.$message.error(res.data.message);
              }
            })
            .finally(() => {
              this.submitLoading = false;
            });
        }
      });
    },

    // ===== 返回 =====
    handleBack() {
      this.$emit("goBack");
    },
  },
};
</script>

<style scoped>
/* ===== 容器 ===== */
.detail-info-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* ===== 页面头部 ===== */
.detail-page-header {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  background: #fff;
  border-bottom: 1px solid #e8eaed;
  flex-shrink: 0;
}
.detail-back-box {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  color: #606266;
  padding: 6px 12px;
  border-radius: 4px;
  background-color: #fff;
  border: 1px solid #dcdfe6;
  margin-right: 16px;
}
.detail-back-box:hover {
  color: #409eff;
  border-color: #409eff;
}
.detail-header-title {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: #303133;
  flex: 1;
}
.detail-header-title i {
  margin-right: 8px;
  color: #409eff;
}
.detail-header-badge {
  margin-left: auto;
}

/* ===== 主体布局 ===== */
.content-box {
  flex: 1;
  display: flex;
  gap: 20px;
  overflow: hidden;
  box-sizing: border-box;
}

/* ===== 左侧表单 ===== */
.detail-form-wrapper {
  flex: 1;
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  overflow-y: auto;
  border: 1px solid #e8eaed;
  height: calc(100% - 60px) !important;
  min-width: 0;
}
.detail-form-wrapper::-webkit-scrollbar {
  width: 4px;
}
.detail-form-wrapper::-webkit-scrollbar-thumb {
  background: #d0d5dd;
  border-radius: 4px;
}

.detail-info-section {
  margin-bottom: 24px;
}
.detail-section-title {
  padding: 0 0 12px 0;
  font-size: 14px;
  font-weight: 500;
  color: #606266;
  border-bottom: 1px solid #e8eef2;
  margin-bottom: 16px;
}

.detail-form-footer {
  display: flex;
  justify-content: center;
  gap: 16px;
  padding-top: 20px;
  margin-top: 8px;
  border-top: 1px solid #e8eef2;
}
.detail-form-footer .el-button {
  min-width: 100px;
}

.img-box {
  width: 130px;
  height: 130px;
}

/* ===== 右侧手机预览 ===== */
.preview-wrapper {
  width: 320px;
  flex-shrink: 0;
}

.phone-frame {
  width: 100%;
  max-width: 296px;
  aspect-ratio: 9 / 19.5;
  background: #000;
  border-radius: 38px;
  padding: 10px;
  position: relative;
}
.phone-frame::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  width: 140px;
  height: 28px;
  background: #000;
  border-radius: 0 0 18px 18px;
  z-index: 10;
}
.phone-frame::after {
  content: "";
  position: absolute;
  top: 18px;
  left: 50%;
  transform: translateX(-50%);
  width: 8px;
  height: 8px;
  background: #1a1a2e;
  border-radius: 50%;
  z-index: 11;
  box-shadow: 0 0 0 2px #2a2a3e, inset 0 0 4px #000;
}

.phone-screen {
  width: 100%;
  height: 100%;
  background: #f9f9f9;
  border-radius: 30px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
}

.status-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 28px 8px 28px;
  background: #f5f6f8;
  flex-shrink: 0;
}
.status-bar .time {
  font-size: 12px;
  font-weight: 700;
  color: #1a1a1a;
}
.status-icons {
  display: flex;
  align-items: center;
  gap: 4px;
}

.top-title {
  width: 100%;
  height: 34px;
  line-height: 34px;
  text-align: center;
  font-size: 14px;
  background: #f5f6f8;
}

.info-box {
  flex: 1;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.info-box::-webkit-scrollbar {
  width: 0;
  height: 0;
}

/* ===== 空状态 ===== */
.preview-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #c0c4cc;
  gap: 10px;
}
.preview-empty i {
  font-size: 42px;
  color: #d0d5dd;
}
.preview-empty span {
  font-size: 13px;
}

/* ===== 轮播图 ===== */
.banner-box {
  background-color: #fff;
  box-shadow: #dcdfe6 0px 2px 7px 0px;
}

/* ===== 卡片通用 ===== */
.info-card,
.spec-card {
  background-color: #ffffff;
  margin: 10px 0;
  padding: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
}

/* ===== 商品信息 ===== */
.price-sales {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 10px;
}
.price-sales .flex-box {
  display: flex;
  align-items: center;
}
.price-sales .price {
  font-size: 22px;
  font-weight: 600;
  color: #e67e22;
}
.price-sales .original-price {
  font-size: 11px;
  color: #d4d4d4;
  padding-left: 4px;
  text-decoration: line-through #d4d4d4;
}
.price-sales .sales {
  font-size: 12px;
  color: #98a6ad;
}
.goods-name {
  font-size: 16px;
  font-weight: 600;
  color: #1e2a36;
  line-height: 1.4;
  margin-bottom: 8px;
}
.goods-brief {
  font-size: 13px;
  color: #7f8c8d;
  line-height: 1.5;
}

/* ===== 规格卡片 ===== */
.spec-card .spec-title {
  font-size: 14px;
  font-weight: 500;
  color: #1e2a36;
  margin-bottom: 12px;
}
.spec-card .spec-list {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  white-space: nowrap;
  gap: 10px;
  padding-bottom: 5px;
}
.spec-card .spec-list::-webkit-scrollbar {
  height: 2px;
  background-color: #eee;
  border-radius: 2px;
}
.spec-card .spec-list::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 2px;
}
.spec-card .spec-list .spec-item {
  display: inline-flex;
  flex-shrink: 0;
  padding: 7px 14px;
  background-color: #f1f2f6;
  border-radius: 10px;
  font-size: 13px;
  color: #4a5b66;
  transition: all 0.2s;
  white-space: nowrap;
  cursor: pointer;
}
.spec-card .spec-list .spec-item.active {
  background-color: #97e5b4ad;
  color: #03833d;
  border: 1px solid #03833d;
}

/* ===== 数量选择卡片 ===== */
.quantity-card {
  background-color: #ffffff;
  margin: 10px 0;
  padding: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* ===== 详情区域 ===== */
.details-box {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  background: #fff;
  padding: 20px 0;
}
.details-box-info-title {
  font-size: 14px;
  font-weight: 500;
  color: #1e2a36;
  margin-bottom: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.details-box-info-li1 {
  width: 60px;
  height: 4px;
  background: linear-gradient(to right, transparent, #64c77df3);
  margin-right: 10px;
}
.details-box-info-li2 {
  width: 60px;
  height: 4px;
  background: linear-gradient(to left, transparent, #64c77df3);
  margin-left: 10px;
}
.details-box-info-img {
  width: 100%;
  object-fit: cover;
}

/* 服务须知 */
.details-box-serve {
  padding: 0 0 8px 0;
}
.details-box-serve-title {
  font-size: 16px;
  font-weight: 600;
  color: #666;
  margin-bottom: 12px;
  text-align: center;
}
.details-box-serve-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: left;
  padding: 0 8px;
}
.details-box-serve-content span {
  font-size: 12px;
  color: #7e7e7e;
  line-height: 1.7;
  display: flex;
  align-items: flex-start;
  text-align: left;
  word-break: break-word;
  white-space: normal;
}
.details-box-serve-content span::before {
  content: "·";
  color: #b6e4f8;
  font-weight: bold;
  margin-right: 4px;
  font-size: 16px;
  flex-shrink: 0;
  line-height: 1.7;
}

/* 注意事项 */
.details-box-precautions {
  padding: 16px 8px 20px 8px;
}
.details-box-precautions-title {
  font-size: 13px;
  font-weight: 600;
  color: #666;
  margin-bottom: 12px;
  text-align: left;
}
.details-box-precautions-content {
  display: flex;
  flex-direction: column;
  padding-left: 0;
}
.details-box-precautions-content span {
  font-size: 12px;
  color: #666;
  line-height: 1.8;
  display: flex;
  align-items: flex-start;
  text-align: left;
  word-break: break-word;
  white-space: normal;
  padding-left: 0;
}
.details-box-precautions-content span::before {
  content: "◆";
  color: #7ec8e3;
  font-weight: 300;
  margin-right: 8px;
  font-size: 11px;
  flex-shrink: 0;
  line-height: 2;
}

/* ===== 底部操作栏 ===== */
.phone-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px 12px 16px;
  background: #fff;
  border-top: 1px solid #f0f2f5;
  z-index: 10;
}
.footer-btn-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 70px;
  margin-left: 10px;
}
.footer-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 10px;
  color: #666;
  gap: 2px;
}
.buy-btn {
  background: linear-gradient(135deg, #07c160, #2abd6b);
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  padding: 0 35px;
  height: 35px;
  line-height: 35px;
  border-radius: 20px;
  letter-spacing: 2px;
}

/* ===== 响应式 ===== */
@media (max-width: 992px) {
  .content-box {
    flex-direction: column;
    height: auto;
    overflow: visible;
  }
  .preview-wrapper {
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
  }
  .phone-frame {
    max-width: 320px;
    margin: 0 auto;
  }
}
</style>